module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-create-entity-button"
  }, [_c('ModalReveal', {
    key: _vm.key,
    ref: _vm.componentId,
    on: {
      "input": _vm.closeInput
    }
  }, [(_vm.policyProp) ? _c('button', {
    staticClass: "button success",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_vm._v("Edit")]) : _c('a', {
    staticClass: "fa-stack fa-lg",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_c('i', {
    staticClass: "fa fa-circle fa-stack-2x"
  }), _c('i', {
    staticClass: "fa fa-plus fa-stack-1x fa-inverse"
  })]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Name"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.policy.name),
      expression: "policy.name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.policy.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.policy, "name", $event.target.value)
      }
    }
  })]), _c('label', [_vm._v("Max bookable hours"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.policy.configuration.max_bookable),
      expression: "policy.configuration.max_bookable"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.policy.configuration.max_bookable)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.policy.configuration, "max_bookable", $event.target.value)
      }
    }
  })]), _c('label', [_vm._v("Min bookable time in minutes"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.policy.configuration.min_bookable),
      expression: "policy.configuration.min_bookable"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.policy.configuration.min_bookable)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.policy.configuration, "min_bookable", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Booking Days")]), _c('div', {
    staticClass: "row"
  }, _vm._l((['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']), function(day) {
    return _c('div', {
      staticClass: "column shrink"
    }, [_c('label', [_vm._v(_vm._s(day) + " "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.policy.configuration.booking_days),
        expression: "policy.configuration.booking_days"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": day,
        "checked": Array.isArray(_vm.policy.configuration.booking_days) ? _vm._i(_vm.policy.configuration.booking_days, day) > -1 : (_vm.policy.configuration.booking_days)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.policy.configuration.booking_days,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = day,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.policy.configuration, "booking_days", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.policy.configuration, "booking_days", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.policy.configuration, "booking_days", $$c)
          }
        }
      }
    })])])
  }), 0), _c('label', [_vm._v("Booking hours")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Start"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.policy.configuration.booking_hours.start),
      expression: "policy.configuration.booking_hours.start"
    }],
    attrs: {
      "type": "text",
      "placeholder": "HH:mm"
    },
    domProps: {
      "value": (_vm.policy.configuration.booking_hours.start)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.policy.configuration.booking_hours, "start", $event.target.value)
      }
    }
  }), (!_vm.startValid) ? _c('div', {
    staticClass: "help-text"
  }, [_vm._v("Invalid format (HH:mm)")]) : _vm._e()])]), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("End"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.policy.configuration.booking_hours.end),
      expression: "policy.configuration.booking_hours.end"
    }],
    attrs: {
      "type": "text",
      "placeholder": "HH:mm"
    },
    domProps: {
      "value": (_vm.policy.configuration.booking_hours.end)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.policy.configuration.booking_hours, "end", $event.target.value)
      }
    }
  }), (!_vm.endValid) ? _c('div', {
    staticClass: "help-text"
  }, [_vm._v("Invalid format (HH:mm)")]) : _vm._e()])])])])]), _c('ActionButton', {
    attrs: {
      "slot": "footer",
      "action": _vm.save,
      "disabled": !_vm.startValid || !_vm.endValid
    },
    slot: "footer"
  }, [_vm._v("Save")]), _c('button', {
    staticClass: "button alert float-right",
    attrs: {
      "slot": "footer"
    },
    on: {
      "click": function($event) {
        return _vm.$refs[_vm.componentId].close()
      }
    },
    slot: "footer"
  }, [_vm._v("Cancel")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-47e9ecac!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/PolicyReveal.vue
// module id = 2458
// module chunks = 1